import {Component, inject} from '@angular/core';
import {
  ACCOUNT_LOGIN_ROUTE,
  DESTINATION_KEY_CONSTANT, FRESH_FROM_SOURCE_CONSTANT, LOGIN_OBJECT_KEY_CONSTANT, PREVIOUS_DESTINATION_KEY_CONSTANT,
  PRODUCT_KEY_CONSTANT,
  REDIRECTED_FLAG_CONSTANT
} from "../constants/routes.constant";
import {from, mergeMap, Subject} from "rxjs";
import {PROGRESS_BAR_SUBJECT} from "../app.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FirebaseAuthService} from "../services/firebase-auth.service";
import {UserProfileService} from "../services/user-profile.service";
import {CreateAccountComponent} from "../create-account/create-account.component";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";

@Component({
    selector: 'app-create-with-google',
    templateUrl: './create-with-google.component.html',
    styleUrl: './create-with-google.component.scss',
    standalone: false
})
export class CreateWithGoogleComponent {
  public inProgress: boolean = false;
  private loginRoute: string = ACCOUNT_LOGIN_ROUTE;
  private productName!: string;
  private destination!: string;
  private loginObject!: string;
  private previousDestination!: string;
  private readonly productNameKey: string = PRODUCT_KEY_CONSTANT;
  private readonly destinationKey: string = DESTINATION_KEY_CONSTANT;
  private readonly loginObjectKey: string = LOGIN_OBJECT_KEY_CONSTANT;
  private readonly previousDestinationKey: string = PREVIOUS_DESTINATION_KEY_CONSTANT;
  public queryParams: { [key: string]: string } = {
    [this.productNameKey]: this.productName,
    [this.destinationKey]: this.destination,
    [this.loginObjectKey]: this.loginObject,
    [this.previousDestinationKey]: this.previousDestination,
  };
  private freshFromSourceKey: string = FRESH_FROM_SOURCE_CONSTANT;
  private freshFromSource!: string;
  public subject: Subject<boolean> = PROGRESS_BAR_SUBJECT;

  private readonly snackBar: MatSnackBar = inject(MatSnackBar);
  private readonly firebaseAuthService: FirebaseAuthService = inject(FirebaseAuthService);
  private readonly userProfileService: UserProfileService = inject(UserProfileService);
  private readonly router: Router = inject(Router);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly location: Location = inject(Location);

  ngOnInit() {
    this.productName = this.activatedRoute.snapshot.queryParamMap.get(
        this.productNameKey
    )!;
    this.destination = this.activatedRoute.snapshot.queryParamMap.get(
        this.destinationKey
    )!;
    this.loginObject = this.activatedRoute.snapshot.queryParamMap.get(
        this.loginObjectKey
    )!;
    this.previousDestination = this.activatedRoute.snapshot.queryParamMap.get(
        this.previousDestinationKey
    )!;
    this.freshFromSource = this.activatedRoute.snapshot.queryParamMap.get(
        this.freshFromSourceKey
    )!;

    if (!this.freshFromSource) {
      this.completeSignUpWithGoogleUsingRedirect();
    } else {
      // reload removing the ffs
      this.removeParamsWithoutNavigation();
      this.signUpWithGoogle();
    }
  }

  public removeParamsWithoutNavigation() {
    const currentPath = this.location.path()
        .replace('&ffs=true', ''); // Get the URL path without the query string

    this.location.replaceState(currentPath); // Replace the current state in history
  }

  public signUpWithGoogle() {
    this.inProgress = true;
    this.subject.next(true);

    from(this.firebaseAuthService.signInWithGoogle()).subscribe({
      next: () => {
        // INFO Nothing here matters because the application is typically closed when the redirect happens
      },
      error: () => {
        this.subject.next(false);
        this.inProgress = false;

        const queryParams = { ...this.queryParams, [FRESH_FROM_SOURCE_CONSTANT]: 'true' };

        this.router.navigate(
          ['/', ...this.loginRoute.split('/')],
          {
            queryParams,
            queryParamsHandling: 'merge',
          }
        );

        this.snackBar.open('An error occurred!', 'close', {
          verticalPosition: 'top',
          horizontalPosition: 'end',
          panelClass: [
            'bg-danger',
            'text-white',
            'rounded-3e',
            'modified-snackbar',
          ],
        });
      },
    });
  }

  public completeSignUpWithGoogleUsingRedirect() {
    this.subject.next(true);
    this.inProgress = true;

    from(this.firebaseAuthService.getIdToken())
        .pipe(mergeMap((d) => this.userProfileService.createUserProfile(d.token, this.productName, this.destination)))
        .subscribe({
          next: () => {
            this.inProgress = false;
            this.subject.next(false);

            CreateAccountComponent.removeOnboardingToken();

            this.router.navigate(['/', ...this.loginRoute.split('/')], {
              queryParams: this.queryParams,
              queryParamsHandling: 'preserve',
            });
          },
          error: () => {
            this.inProgress = false;
            this.subject.next(false);
            this.snackBar.open('An error occurred!', 'close', {
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: [
                'bg-danger',
                'text-white',
                'rounded-3e',
                'modified-snackbar',
              ],
            });
          },
        });
  }
}
